import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MESSAGE_TEXT } from 'src/app/const/message';
import { BUTTON, COMMON_TEXT } from 'src/app/const/text-common';
import { ButtonType, SaveType } from 'src/app/enum/common-enum';
import { ModalTemplate } from 'src/app/models/common-model';

@Component({
  selector: 'pivot-dialog-add-new-staff-to-team-by-drag',
  templateUrl: './dialog-add-new-staff-to-team-by-drag.component.html',
  styleUrls: ['./dialog-add-new-staff-to-team-by-drag.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogAddNewStaffToTeamByDragComponent implements OnInit {
  teamName: string;
  buttonType = ButtonType;
  saveType = SaveType;
  BUTTON = BUTTON;
  MESSAGE_TEXT = MESSAGE_TEXT;
  modalParam: any;
  modalData: ModalTemplate = new ModalTemplate();
  isDarkMode: boolean;
  constructor(public ref: DynamicDialogRef,
    public config: DynamicDialogConfig) { 
      this.config.showHeader = true;
      this.config.style = { 
        width: '35%',
        header: COMMON_TEXT.CONFIRM
      };
      this.modalParam = this.config.data.modalParam;
      this.teamName = this.modalParam.description;
      const bodyElement = document.getElementsByTagName("body")[0];
      this.isDarkMode = bodyElement.classList.contains("navi") || bodyElement.classList.contains("dark") ? true : false;
    }

  ngOnChanges(){
  }
  
  ngOnInit(){
  }
  
  onSubmit(data: number) {
    this.ref.close(data);
  }
}
